export default __webpack_public_path__ + "static/media/back_webtoon_02.d408611e.png";